import { Modal } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { Formik } from "formik";
import FormField from "../../common/FormField/FormField";
import { PrimaryCTAButton } from "../../common/Buttons";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import { getErrorMessage } from "../../../helpers/functions";

const AnswerModal = ({ modal, setModal, viewer }) => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "put questions..." });
      const payload = {
        eventId: String(viewer?.id),
        fromViewerId: String(modal?.viewerId),
        messageText: values?.messageText,
        questionId: String(modal?.questionId),
        name: viewer?.name,
        role: "host",
      };
      const response = await EventService.saveEventAnswers(payload);
      if (response) {
        enqueueSnackbar("Answer sent successfully", {
          variant: "success",
        });
      }
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setModal({ state: false });
    }
  }

  return (
    <Modal open={modal?.state} onClose={() => setModal({ state: false })}>
      <DrawerContainer>
        <Container>
          <HeadingContainer>
            <CloseModal
              onClick={() => setModal({ state: false })}
              src={require("../../../assets/images/closeModal.svg")}
            />
          </HeadingContainer>
          <FormContainer>
            <Formik
              initialValues={{
                messageText: "",
              }}
              enableReinitialize
              validateOnBlur
              validationSchema={""}
              validateOnChange
              onSubmit={onFormSubmit}
            >
              {({
                values,
                handleChange,
                errors,
                handleSubmit,
                touched,
                setFieldValue,
                setFieldError,
                handleBlur,
              }) => (
                <form>
                  <div style={{ marginTop: 17, display: "flex" }}>
                    <div style={{ width: "90%" }}>
                      <FormField
                        input={{
                          name: "messageText",
                          label: "Answer",
                          type: "textarea",
                          placeholder: "Type your answer here",
                        }}
                        style={{ backgroundColor: "#f9f9f9" }}
                        multiline
                        maxLength={0}
                        {...{
                          touched,
                          errors,
                          values,
                          handleChange,
                          handleBlur,
                        }}
                      />
                    </div>
                    <PrimaryCTAButton
                      style={{
                        marginLeft: "10px",
                        marginTop: "30px",
                        width: "90px",
                        height: "15px",
                        padding: "10px 10px",
                      }}
                      onClick={handleSubmit}
                    >
                      SEND
                    </PrimaryCTAButton>
                  </div>
                </form>
              )}
            </Formik>
          </FormContainer>
        </Container>
      </DrawerContainer>
    </Modal>
  );
};

export default AnswerModal;

const Container = styled.div`
  margin: 0 15px;
  background-color: rgb(249, 249, 249, 0.8);
  outline: none;
  border-radius: 8px;
  @media ${theme?.breakpoints?.sm_up} {
    margin: 0;
  }
`;

const DrawerContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media ${theme?.breakpoints?.sm_up} {
    max-width: 60%;
  }
`;

const HeadingContainer = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const FormContainer = styled.p`
  padding-top: 14px;
  padding-left: 54px;
  padding-right: 54px;
  padding-bottom: 26px;
  & form {
    padding-top: 10px;
  }
`;

const CloseModal = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  cursor: pointer;
  position: absolute;
  right: 10px;
`;
